import { REQUIRED_MESSAGE, requiredString } from '@wyz/utils';
import { z } from 'zod';
export const DUPLICATE_PP_MODAL_ACTION = {
  SAVE_AS_DRAFT: 'SAVE_AS_DRAFT',
  SAVE_AND_APPLY: 'SAVE_AND_APPLY',
} as const;

export const duplicatePolicyFormSchema = z.object({
  customerIds: z
    .array(
      z.object({
        label: requiredString,
        value: requiredString,
      }),
      {
        error: (issue) =>
          issue.input === undefined ? REQUIRED_MESSAGE : undefined,
      },
    )
    .min(1, REQUIRED_MESSAGE),
  action: z.enum(DUPLICATE_PP_MODAL_ACTION, {
    error: REQUIRED_MESSAGE,
  }),
});
